<template>
  <PaymentPanel
    :title="$t('payment.title')"
    :student_id="student_id"
    student_mode
  />
</template>

<script>
import PaymentPanel from "./components/PaymentPanel.vue";

export default {
  name: "payment",
  components: {
    PaymentPanel,
  },
  computed: {
    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },
  },
};
</script>
